<div class="content-header">
  <h1>Redis Manager</h1>
</div>

<div class="redis-manager gs-fill">
  <div class="toolbar">
    <form class="redis-search" (submit)="onSearchSubmit($event)">
      <sdc-input
        name="redis-search"
        placeholder="Search"
        [control]="searchControl"
        [attr.data-cy]="'redis-search-input'" />
      <sdc-button
        variant="secondary"
        type="submit"
        [attr.data-cy]="'redis-search-button'">
        <ng-icon name="lucideSearch" aria-hidden="true" />
        <span>Search</span>
      </sdc-button>
    </form>
    @if (selectedKeys().size) {
      <sdc-button variant="destructive" (onClick)="openModalDeleteAll()">
        <ng-icon name="lucideTrash2" aria-hidden="true" />
        <span>Delete selected keys</span>
      </sdc-button>
    }
  </div>

  @for (epoch of [tableEpoch()]; track epoch) {
    <gs-table
      class="keys-table"
      [data]="data()"
      [columns]="columns"
      [selectable]="true"
      (selectionChange)="onSelectionChange($event)" />
  }

  @if (nextCursor && nextCursor !== '0') {
    <div class="load-more">
      <sdc-button variant="secondary" (onClick)="getNextKeys($event)">
        Load more keys
      </sdc-button>
    </div>
  }

  <sdc-card headerTitle="Redis value viewer" class="value-viewer">
    @if (redisRecord) {
      <div [attr.data-cy]="'redis-record-viewer'">
        <sdc-info-grid
          [items]="[{ label: 'Key', value: redisRecord.key }]"
          [columns]="1" />
        <div class="value-block">
          <span class="value-label">Value</span>
          <pre>{{ json }}</pre>
        </div>
      </div>
    } @else {
      <p>No redis key selected.</p>
    }
  </sdc-card>
</div>

@if (refreshing) {
  <div class="loading">
    <div class="text-container">
      <div>
        <span>Loading Redis Keys</span>
      </div>
      <div>
        <div class="dot-typing"></div>
      </div>
    </div>
  </div>
}
